export default "__VITE_ASSET__DQc_b4W1__"